import React from "react";
import { object } from "prop-types";
import { Table } from "reactstrap";

import MonitoringQueueEntryScoringDetailsTableRow from "./row";
import "./monitoringQueueEntryScoringDetailsTable.css";

const MonitoringQueueEntryScoringDetailsTable = ({ details }) => {
  const defineColor = (profileName) => {
    const profileNameToLower = profileName.toLowerCase();
    if (profileNameToLower.includes("high")) {
      return "high-label";
    }
    if (profileNameToLower.includes("medium")) {
      return "medium-label";
    }
    if (profileNameToLower.includes("normal")) {
      return "normal-label";
    }
    return "";
  };

  const defineColoringClassName = (profileName = "") => {
    const profileNameToLower = profileName.toLowerCase();
    if (profileNameToLower.includes("high")) {
      return "score-card-risk-profile-name-high";
    }
    if (profileNameToLower.includes("medium")) {
      return "score-card-risk-profile-name-medium";
    }
    if (profileNameToLower.includes("normal")) {
      return "score-card-risk-profile-name-normal";
    }
    return "";
  };

  const rows = details.clientScoringResult.detailedResultList.map((entry) => (
    <MonitoringQueueEntryScoringDetailsTableRow
      key={entry.scoreCardRiskFactorName}
      entry={entry}
      color={defineColor(entry.scoreCardRiskProfileName)}
    />
  ));

  return (
    <React.Fragment>
      <Table className="monitoring-queue-entry-scoring-details-table">
        <thead className="thead-light">
          <tr>
            <th colSpan="3" className="center">
              <b>
                Matrix name&nbsp;:&nbsp;
                {details.clientScoringResult.scoreCard.name}
              </b>
            </th>
          </tr>
          <tr className="bg-gray">
            <td>
              <b>Parameter name</b>
            </td>
            <td>
              <b>Parameter value</b>
            </td>
            <td>
              <b>Parameter score</b>
            </td>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
        <tfoot
          className={defineColoringClassName(
            details.clientScoringResult.scoreCardRiskProfileName
          )}
        >
          <tr>
            <td style={{color:"#F3F3F3"}} colSpan="2" align="right">
              Summary score:
            </td>
            <td className="score-card-risk-label">
              <b>{details.clientScoringResult.scoreCardRiskProfileName}</b>
            </td>
          </tr>
        </tfoot>
      </Table>
      <br />
      <br />
    </React.Fragment>
  );
};

MonitoringQueueEntryScoringDetailsTable.propTypes = {
  details: object.isRequired,
};

export default MonitoringQueueEntryScoringDetailsTable;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/scoring/scoring-details-table/MonitoringQueueEntryScoringDetailsTable.jsx